import DomainCard from './DomainCard';

export default DomainCard;
